import terminalRuntimeConfig from "./terminalRuntimeConfig";

export const EMAIL_REGEXP =
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const DEFAULT_TIMEZONE = "Europe/Berlin";
export const TERMINAL_INACTIVITY_TIME = terminalRuntimeConfig.TERMINAL_INACTIVITY_TIME;
export const DEFAULT_ROTATE_ADS = terminalRuntimeConfig.DEFAULT_ROTATE_ADS;
export const VERIFY_THEME_TIME = 60 * 1000; // 1min
export const LIGHT_THEME_TIME_FROM = 6; //6am
export const LIGHT_THEME_TIME_TO = 17; //5pm

// Max upload size for ad poster media
export const MAX_VIDEO_UPLOAD_SIZE = 150 * 1024 * 1024; // 150MB for videos
export const MAX_IMAGE_UPLOAD_SIZE = 25 * 1024 * 1024; // 25MB for images
